class VoucherController extends AbstractController
	@register()
	@inject '$scope',
		'translate'
		'RenderRepository'
		'ToastService'
		'VoucherRepository'
		'BACKEND_TRANSACTION_STATE'
		'voucher'
		'transactions'
		'parseBool'

	initialize: ->
		@mainCrud.entityTitle = 'general.vouchers'
		@mainCrud.showFormActionButtons = false

		if !_.isEmpty @voucher
			@initialTransaction = _.find(@transactions, {state: @BACKEND_TRANSACTION_STATE.DEPOSITED})
			# Valid is when Gift card is not expired, has units left and voucher type is not deleted
			@isValid = !@voucher.voucher_type.deleted? &&
				(!@voucher.expire_date? || @voucher.expire_date >= moment().unix()) &&
				@getAttribute(@voucher, 'units_left') > 0

			@isActive = @parseBool(@voucher.active, true)

			@tabs = [
				{
					title: 'wbo.voucher.info'
					selector: '#tab-voucher-info'
				}
				{
					title: @translate('wbo.order.history') + " (" + @transactions.length + ")"
					selector: '#tab-voucher-history'
					disabled: @transactions.length == 0
				}
			]

			for transaction in @transactions
				transaction.state_type = 'used'

				if transaction.state == @BACKEND_TRANSACTION_STATE.DEPOSITED
					transaction.state_type = 'bought'

				if transaction.state == @BACKEND_TRANSACTION_STATE.CANCELLED
					transaction.state_type = 'cancelled'

				if transaction.state == @BACKEND_TRANSACTION_STATE.REFUNDED
					transaction.state_type = 'returned'

	getAttribute: (voucher, attribute) ->
		if voucher.attributes?
			for attributes in voucher.attributes
				for own label, value of attributes
					if label == attribute
						return value
		return null

	resendEmail: (updateWithNewValue = true) ->
		if @emailForm.$valid
			@VoucherRepository
				.sendEmail @voucher.email, @voucher.id, updateWithNewValue
				.then (response) =>
						@ToastService.add(
							response.data.success,
							@translate('general.voucher'),
							@translate('bounty.email.sent'),
							'success'
						)
					.catch (response) =>
						@ToastService.showErrors response, @translate('general.voucher')

	getFullInformationLink: ->
		return @RenderRepository.getDownloadUrl('vouchers', @voucher.id, 'html')

	setStatus: (status) ->
		@VoucherRepository
			.setStatus @voucher.id, status
			.then (response) =>
				@ToastService.add(
					response.data.name,
					@translate('general.voucher'),
					@translate('general.' + (if status then 'activated' else 'deactivated')),
					'success'
				)
				@isActive = status
				@voucher.active = status
			.catch (response) =>
				@handleErrors response 'general.voucher'
